// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
// ANTD
import Table from 'antd/lib/table';
import Fuse from 'fuse.js';
// COMPONENTS
import SearchBox from 'components/inputs/SearchBox';

//------------------------------------------------------------------------------
// CONSTANTS:
//------------------------------------------------------------------------------
const columns = [
  {
    title: '_id',
    dataIndex: '_id',
    key: '_id',
    render: _id => <Link to={`/admin/users/${_id}`}>{_id}</Link>,
  },
  {
    title: 'email',
    dataIndex: 'emails.0.address',
    key: 'emails.0.address',
  },
  {
    title: 'first',
    dataIndex: 'profile.firstName',
  },
  {
    title: 'last',
    dataIndex: 'profile.lastName',
  },
  {
    title: 'role',
    dataIndex: 'roles',
    key: 'roles',
  },
];

//------------------------------------------------------------------------------
// COMPONENT:
//------------------------------------------------------------------------------
class AdminUsersTable extends React.PureComponent {
  state = {
    users: [],
    results: [],
    searchText: '',
  };

  toggleForm = () => {
    this.setState({ visible: !this.state.visible });
  };

  disableBtn = () => {
    this.setState({ disabled: true });
  };

  enableBtn = () => {
    this.setState({ disabled: false });
  };

  handleCancel = () => {
    this.enableBtn();
    this.toggleForm();
  };

  filterOptions = searchText => {
    let searchOptions;
    this.setState({ searchText });
    searchOptions = this.state.users.map(item => ({
      ...item,
      email: item.emails[0].address,
    }));
    if (searchText.length === 0) {
      this.setState({ results: this.state.users });
    }
    let fuse = new Fuse(searchOptions, {
      shouldSort: true,
      threshold: 0.5,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: ['profile.firstName', 'profile.lastName', 'email'],
    });

    let searchResults = fuse.search(searchText);
    if (searchResults && searchResults.length > 0) {
      return this.setState({ results: searchResults });
    }
  };

  componentWillReceiveProps(newProps) {
    this.setState({ users: newProps.users, results: newProps.users });
  }

  componentDidMount(newProps) {
    this.setState({ users: this.props.users, results: this.props.users });
  }

  render() {
    return (
      <div>
        <Table
          rowKey={record => record._id}
          columns={columns}
          loading={this.props.loading}
          onChange={this.props.onChange}
          dataSource={this.state.results}
          pagination={{ pageSize: this.props.pageSize, total: this.props.total }}
        />
      </div>
    );
  }
}

AdminUsersTable.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  data: PropTypes.shape({
    error: PropTypes.object,
    loading: PropTypes.bool.isRequired,
    users: PropTypes.array,
  }).isRequired,
  adminCreateUser: PropTypes.func.isRequired, // mutation
};

AdminUsersTable.defaultProps = {
  children: null,
  pageSize: 5,
  onChange: () => {},
};

export default AdminUsersTable;



// WEBPACK FOOTER //
// ./src/routes/admin-users/AdminUsersTable/index.js